import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Printer, Pencil, Trash2, FileText } from "lucide-react";
import { toast } from "sonner";
import { api, errorText } from "@/lib/api";
import { StudySheetForm } from "@/components/StudySheetForm";

export const StudySheetsPanel = ({ terms }) => {
  const [sheets, setSheets] = useState([]);
  const [editing, setEditing] = useState(null);
  const [open, setOpen] = useState(false);

  const load = useCallback(() => api.get("/study-sheets").then((r) => setSheets(r.data)), []);
  useEffect(() => { load(); }, [load]);

  const remove = async (s) => {
    if (!window.confirm(`Eliminare il foglio "${s.title}"?`)) return;
    try {
      await api.delete(`/study-sheets/${s.id}`);
      load();
    } catch (e) {
      toast.error(errorText(e));
    }
  };

  return (
    <div data-testid="sheets-panel">
      <button onClick={() => { setEditing(null); setOpen(true); }} data-testid="sheet-add-button" className="ink-box-sm ink-press flex items-center gap-2 rounded-full bg-[var(--sun)] px-5 py-2 font-extrabold">
        <Plus className="h-4 w-4" /> Nuovo foglio di studio
      </button>
      {sheets.length === 0 && <p className="mt-5 font-semibold text-neutral-500" data-testid="sheets-empty">Nessun foglio. Crea il primo per la prossima verifica!</p>}
      <div className="mt-5 grid gap-4 sm:grid-cols-2">
        {sheets.map((s) => (
          <div key={s.id} className="ink-box-sm flex items-center gap-3 rounded-2xl bg-white p-4" data-testid={`sheet-card-${s.id}`}>
            <FileText className="h-6 w-6 shrink-0" />
            <div className="min-w-0 flex-1">
              <p className="font-display truncate text-lg font-bold">{s.title}</p>
              <p className="text-xs font-bold text-neutral-500">{s.term_ids.length} parole</p>
            </div>
            <Link to={`/docente/fogli/${s.id}`} data-testid={`sheet-print-${s.id}`} aria-label="Stampa" className="rounded-full border-2 border-[var(--ink)] bg-[var(--sky)] p-2 text-white"><Printer className="h-4 w-4" /></Link>
            <button onClick={() => { setEditing(s); setOpen(true); }} data-testid={`sheet-edit-${s.id}`} aria-label="Modifica" className="rounded-full border-2 border-[var(--ink)] p-2 hover:bg-[var(--sun)]"><Pencil className="h-4 w-4" /></button>
            <button onClick={() => remove(s)} data-testid={`sheet-delete-${s.id}`} aria-label="Elimina" className="rounded-full border-2 border-[var(--ink)] p-2 hover:bg-red-200"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
      <StudySheetForm open={open} onClose={() => setOpen(false)} sheet={editing} terms={terms} onSaved={load} />
    </div>
  );
};
